import { render, staticRenderFns } from "./ProceduresDetails.vue?vue&type=template&id=e21444f2"
import script from "./ProceduresDetails.vue?vue&type=script&lang=js"
export * from "./ProceduresDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports